import { Component, OnInit } from "@angular/core";
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { NgbModal, NgbModalRef, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { NotificationService } from './notification.service';
import { NgxSpinnerService } from "ngx-spinner";
import { FormBuilder, FormGroup, Validators, FormControl } from "@angular/forms";
import Swal from "sweetalert2";
import { RESPONSE } from "src/app/common/common.const";
@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  closeResult: string;
  userDetails: object;
  statusFormSubmitted: boolean = false;
  formSubmitted: boolean = false;
  notificationList = [];
  memberList=[];
  userList=[];
  NotificationForm: FormGroup;
  private modalRef: NgbModalRef;

  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
    centered: true,
  };

  searchText: string = "";
  constructor(
    private modalService: NgbModal,
    private NotificationService: NotificationService,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService
  ) { }
  ngOnInit() {
    this.getNotification();
  }
  getNotification() {

    this.spinner.show();
    this.NotificationService.NotificationList().subscribe(res => {
      if (res["message"] = "Success") {
        this.notificationList = res.data.notificationList;
        this.spinner.hide();
      } else {
        this.notificationList = [];
        this.spinner.hide();
      }
    });
  }
  type="allUsers"
  change(){

  }


  sendNotificationForm() {
    this.NotificationForm = this.formBuilder.group({
      title: ["", [Validators.required]],
      text: ["", [Validators.required]],
    });
    this.type="allUsers";
    this.memberList = [];
  }
  SendMessage(test) {
    this.formSubmitted = true;
    if (this.NotificationForm.valid) {
      this.spinner.show();
      let formValue = this.NotificationForm.value;
      let finalObj = {
        title: formValue.title,
        message: formValue.text,
        notificationType:this.type
      };
      if(this.type == 'users'){
          finalObj['userIds']=this.memberList;
      }


      this.NotificationService.SendNotification(finalObj).subscribe(data => {
        this.spinner.hide();

        if (data["message"] = "Success") {
          Swal.fire("Success", "Message Send successfully!", "success");
          this.modalRef.close();
          this.getNotification();
        } else {
          this.modalRef.close();
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });
    }
    this.spinner.hide();
  }
  closeModal(){
    this.modalRef.close();
  }
  sendNotification(row, content, btn) {
    this.userList =[];
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.userDetails = row;
    this.formSubmitted = false;
    this.memberList = [];
    this.sendNotificationForm();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  sendNotification1(row, content, btn) {
    btn && btn.parentElement && btn.parentElement.parentElement && btn.parentElement.parentElement.blur();
    this.userList = row;
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  serachText: "";
  citySearchChanged(event: any) {
    this.serachText = null;
    this.userList = []
    this.loadUserList(event.term);

  }
  userSelected(event: any) {
    if (event != null) { 
    }
  }
  loadUserList(name) {
    let query = "offset=0&limit=20&status=active&text=" + name;
    this.NotificationService.getUsersDropDownList(query).subscribe(res => {
      console.log("user list:::::::::::: ",res);
      if (res['message'] == 'Success') {  
        this.userList = res.data.userList;
        this.userList.forEach(element => {
          element['fullName'] = element['firstName']+" "+element['lastName'] + " " + `[${element['userName']}]`;
          
        });
      }


    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }


}
